import {Navigate, Outlet} from 'react-router-dom'
import {useAppSelector} from '../store/hooks.ts'

interface ProtectedRouteProps {
  requiredRole?: string
}

const ProtectedRoute = ({ requiredRole }: ProtectedRouteProps) => {
  const { isAuthenticated, user } = useAppSelector(state => state.auth)

  // If not authenticated, redirect to login
  if (!isAuthenticated || !user) {
    return <Navigate to="/" replace />
  }

  // If a specific role is required and user doesn't have it, redirect to a safe start page
  if (requiredRole && !user.roles.includes(requiredRole.toUpperCase())) {
    // Determine the appropriate redirect based on user roles
    let redirectPath = '/'; // Default redirect to login

    if (user.roles.includes('SYSTEM_ADMIN')) {
      redirectPath = '/system-admin/settings';
    } else if (user.roles.includes('ADMIN')) {
      redirectPath = '/admin/catalogs/users';
    } else if (user.roles.includes('OPERATOR')) {
      redirectPath = '/operator/person';
    }

    return <Navigate to={redirectPath} replace />
  }

  // If authenticated and has the required role (or no specific role is required), render the children
  return <Outlet />
}

export default ProtectedRoute
